import { render } from "./ScheduleAppointment.vue?vue&type=template&id=f4998dfa&ts=true"
import script from "./ScheduleAppointment.vue?vue&type=script&lang=ts"
export * from "./ScheduleAppointment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__